import '@fontsource/poppins/300.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/500.css'
import '@fontsource/poppins/700.css'

import { createTheme } from '@mui/material/styles'
import tokens from './tokens/tokens'

const theme = (mode) => {
  return createTheme({
    breakpoints: {
      values: { ...tokens.breakpoints },
    },
    typography: {
      fontFamily: tokens.typography.desktop.fontFamily,
    },
    colorSchemes: {
      dark: {
        palette: {
          contrastThreshold: 4.5,
          ...tokens.palette['dark'],
        },
      },
      light: {
        palette: {
          contrastThreshold: 4.5,
          ...tokens.palette['light'],
        },
      },
    },
    shape: tokens.shape,
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            color: 'white',
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          track: {
            backgroundColor: 'black',
            opacity: 0.2,
          },
        },
      },
    },
  })
}

export default theme
